export { createWidget } from "./widget";
export { detectHostTheme } from "./theme";
export type { BitPalmAgentOptions, BitPalmAgentInstance, BitPalmIdentifyPayload, BitPalmCustomContext, BitPalmEventType, BitPalmEventCallback, BitPalmTheme } from "./types";

import { createWidget } from "./widget";
import { normalizeThemeSetting } from "./theme";
import { parseTriggerMode, triggersOption } from "./triggers";

function parseBoolean(value: string | undefined): boolean | undefined {
  if (value == null) return undefined;
  const normalized = value.trim().toLowerCase();
  if (["1", "true", "yes", "on"].includes(normalized)) return true;
  if (["0", "false", "no", "off"].includes(normalized)) return false;
  return undefined;
}

/**
 * Auto-init from script tag:
 * <script src="https://cdn.bitpalm.ai/widget.js" data-slug="my-agent"></script>
 * Optional: data-launcher="false" and data-triggers="events" or "false".
 */
if (typeof document !== "undefined") {
  const script = document.currentScript as HTMLScriptElement | null;
  if (script?.dataset.slug) {
    const init = () => {
      createWidget({
        slug: script!.dataset.slug!,
        locale: script!.dataset.locale,
        baseUrl: script!.dataset.baseUrl,
        token: script!.dataset.token,
        zIndex: script!.dataset.zIndex ? Number(script!.dataset.zIndex) : undefined,
        autoIdentify: parseBoolean(script!.dataset.autoIdentify),
        theme: normalizeThemeSetting(script!.dataset.theme),
        launcher: parseBoolean(script!.dataset.launcher),
        triggers: script!.dataset.triggers === undefined ? undefined : triggersOption(parseTriggerMode(script!.dataset.triggers)),
      });
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  }
}
